import { GET_DAILYCUSTOMER_REQUESTED, GET_RIDEANALYTIC_REQUESTED, GET_RIDE_REQUESTED, GET_TOTALREGISTRATION_REQUESTED } from "resources/actionTypes";


export function getRideDetails(data) {
  return {
    type: GET_RIDE_REQUESTED,
    payload:data
  };
}

export function getTotalRegistration(data) {
  return {
    type: GET_TOTALREGISTRATION_REQUESTED,
    payload:data
  };
}

export function getDailyCustomer(data) {
  return {
    type: GET_DAILYCUSTOMER_REQUESTED,
    payload:data
  };
}

export function getRideAnalytic(data) {
  return {
    type: GET_RIDEANALYTIC_REQUESTED,
    payload:data
  };
}